import React, { useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import SelectInput from '../../../Misc/SelectInput/SelectInput.jsx';
import Tabela from '../../../Misc/Tabela/Tabela.jsx';
import ModalAcompanhamentoMetas from './ModalAcompanhamentoMetas.jsx';
import { useAcompanhamentoMetas } from "./AcompanhamentoMetascontext.js";
import styles from './AcompanhamentoMetas.module.scss';
import MiniModalJustificativa from './ModalJustificativasAcompanhamentoMetas.jsx';

const AcompanhamentoMetasMain = () => {
    const {
        mainData,
        handleShowCad,
        handleSearch,
        filterObj,
        handleSetFilterObj,
        listagem,
        showCad,
        handleOpenModalJustificativa,
        showJustificativa,
        idDemandaSelecionada,
        handleCancelMeta
    } = useAcompanhamentoMetas();

    const reportColumns = [
        {
            name: '',
            cell: (row) => (
                <Button
                    className={styles.cancelButton}
                    onClick={() => handleCancelMeta(row.IdDemanda)}
                >
                    X
                </Button>
            ),
            width: '50px',
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
        { name: 'Data Programação', selector: row => row.dataProgramacao || 'N/A' },
        { name: 'Encarregado', selector: row => row.encarregado || 'N/A' },
        { name: 'Meta', selector: row => row.meta || 'N/A' },
        { name: 'Realizado', selector: row => row.realizado || 'N/A' },
        { name: '%Realizado', selector: row => `${row.percentualRealizado ? `${parseFloat(row.percentualRealizado)}%`: 'N/A'}` || 'N/A' },
        {
            name: 'Ações',
            cell: (row) => (
                <Button
                    className={styles.justifyButton}
                    onClick={() => handleOpenModalJustificativa(row)}
                >
                    Justificativa
                </Button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const customFilter = (option, searchText) => {
        if (!searchText) return true;
        return option.label.toLowerCase().includes(searchText.toLowerCase());
    };

    const customSelectStyles = {
        container: (provided) => ({
            ...provided,
            width: '168.5px',
        }),
        control: (provided, state) => ({
            ...provided,
            borderColor: state.isFocused ? '#dee2e6' : '#dee2e6',
            boxShadow: state.isFocused ? '0 0 0 1px #dee2e6' : 'none',
            '&:hover': { borderColor: '#dee2e6' },
        }),
        singleValue: (provided) => ({
            ...provided,
            fontSize: '12px',
        }),
        input: (provided) => ({
            ...provided,
            fontSize: '12px',
        }),
        placeholder: (provided) => ({
            ...provided,
            fontSize: '12px',
        })
    };

    return (
        <div>
            <article className="d-flex align-items-center">
                <h3 className="p-3">Acompanhamento de Metas</h3>
                <Button
                    type="button"
                    variant="info"
                    className={styles.attachBtn}
                    onClick={handleShowCad}
                >
                    + Adicionar Demanda
                </Button>
            </article>
            <article>
                <Form className={styles.formWrapper}>
                    <SelectInput
                        placeholder={'Selecione a data'}
                        label={'Data Programação'}
                        filterOption={customFilter}
                        onChange={e => handleSetFilterObj('dataProgramacao', e)}
                        options={listagem.dataProgramacao}
                        value={filterObj.dataProgramacao || null}
                        customSelectStyles={customSelectStyles}
                        isClearable={true}
                    />
                    <SelectInput
                        placeholder={'Selecione a equipe'}
                        label={'Equipe'}
                        filterOption={customFilter}
                        onChange={e => handleSetFilterObj('equipe', e)}
                        options={listagem.equipe}
                        value={filterObj.equipe || null}
                        customSelectStyles={customSelectStyles}
                        isClearable={true}
                    />
                    <Button
                        type="button"
                        variant="primary"
                        className={`${styles.searchBtn}`}
                        onClick={handleSearch}
                    >
                        Buscar
                    </Button>
                </Form>
            </article>
            <article style={{ margin: '20px 20px 20px' }}>
                <Tabela
                    columns={reportColumns}
                    data={mainData}
                    pending={false}
                    paginationPerPage={20}
                    highlightOnHover={false}
                    color="#000000"
                    conditionalRowStyles={[
                        {
                            when: (row) => true,
                            style: {
                                backgroundColor: '#F7F7F7',
                                color: '#000000',
                                cursor: 'default'
                            },
                        },
                    ]}
                />
            </article>
            {showCad && <ModalAcompanhamentoMetas />}
            {showJustificativa && <MiniModalJustificativa idDemandaSelecionada={idDemandaSelecionada} />}
        </div>
    );
};

export default AcompanhamentoMetasMain;